import script from "./fullscreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./fullscreen.vue?vue&type=script&setup=true&lang=ts"

import "./fullscreen.vue?vue&type=style&index=0&id=bf3bf26c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf3bf26c"]])

export default __exports__